// This handles cases where a numeric value might be returned as a string instead of a number.
// It's better to use a formatter than hardcode the $ in case we need to switch this out for another currency.
// TODO: Add a "currency" param for internationalization
// TODO: Add a default value param for null / undefined.
export default function formatCurrency(amount?: string | number | null): string {
  return amount !== undefined && amount !== null && (typeof amount === 'number' || !isNaN(+amount))
    ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(+amount)
    : 'N/A'
}
